import { Button, Form, Input, Switch, message } from 'antd'
import React, { useState, useRef, Fragment, useImperativeHandle, useEffect } from 'react'
import { randomString } from '@/utils/utils'
import styles from './login.scss'
import Protocol from '../registerForm/Protocol'
import Privacy from '../registerForm/Privacy'
import wrapWithUser from '@/components/wrapWithUser'
import { SYSCON } from '@/const/const'
import pcLoginImg from '@/common/images/icon/pc_rc_1.png'
import qrLoginImg from '@/common/images/icon/qr_rc_1.png'
import LoginQr from './login-qr'
// import ChangePwd from './changePwd'
const LoginForm = (props) => {
  // 属性
  const { handleLoginSuccess, handleModalClose, handleRegistClick, handleChangePwd, handleForgetClick } = props
  const formRef = useRef()
  const [identityCode, handleCode] = useState(1)
  const [imgSrc, handleImgSrc] = useState()
  const [remCk, handleCk] = useState()
  const [qrFlag, setQrFlag] = useState(false)
  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      open
    }
  })

  const open = () => {
    reloadCodeImg()
    // TODO 如何等待dom加载后 处理
    setTimeout(()=>{
      handleRemember()
    }, 500)
  }

  // 初始化
  useEffect(()=>{
    open()
  }, [])
  // 获取图片url
  const getRandomUrl = () => {
    const rkey = randomString(10)
    handleCode(rkey)
    return process.env.REACT_APP_BASE_URL + '/service/auth/auth-code/get?identityCode=' + rkey
  }
  // 重新加载图片
  const reloadCodeImg = () => {
    const url = getRandomUrl()
    handleImgSrc(url)
  }
  // 登录请求
  const handleAdd = async(fields) => {
    // 加载信息
    const hide = message.loading('正在登录')
    try {
      const userInfo = await props.user.login(fields)
      hide()
      message.success('登录成功')
      return userInfo
    } catch (error) {
      reloadCodeImg()
      hide()
      console.log('login_error', error)
    }
  }
  const _getQueryString = function(name) {
    console.log('name', name)
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    const r = window.location.search.substr(1).match(reg)
    if (r != null) return JSON.parse(unescape(r[2]))
    return false
  }
  const funcUrlDel = function(url, key) {
    const baseUrl = url.split('?')[0] + '?'
    const query = url.split('?')[1]
    if (query.indexOf(key) > -1) {
      const obj = {}
      const arr = query.split('&')
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split('=')
        obj[arr[i][0]] = arr[i][1]
      }
      delete obj[key]
      const url =
            baseUrl +
            JSON.stringify(obj)
              .replace(/[\"\{\}]/g, '')
              .replace(/\:/g, '=')
              .replace(/\,/g, '&')
      return url
    } else {
      return url
    }
  }
  // 处理登录
  const handleLogin = async() => {
    const fromData = formRef.current.getFieldsValue(true)
    const password = window.btoa(fromData.password)
    const userInfo = await handleAdd({ ...fromData, password, identityCode, appCatCd: '9050.170' })
    // 密码强度弱
    if (userInfo && !userInfo.pwdComplexity) {
      handleChangePwd()
      localStorage.setItem(SYSCON.GelFinanceChangePws, true)
    } else {
      localStorage.removeItem(SYSCON.GelFinanceChangePws)
    }
    if (userInfo) {
      const orgs = userInfo.orgs
      if (orgs.length === 1) {
        // 默认组织信息
        localStorage.setItem(SYSCON.orgIdLocal, orgs[0].id)
        localStorage.setItem(SYSCON.orgNmLocal, orgs[0].nm)
      } else {
        localStorage.removeItem(SYSCON.orgIdLocal)
        localStorage.removeItem(SYSCON.orgNmLocal)
      }
      setRemember(userInfo)
      handleModalClose()
      await props.user.handleUserInfo(userInfo)
      props.setStatu(props.user.getLoginStatu())
      handleLoginSuccess && handleLoginSuccess(userInfo)
      if (_getQueryString('logoutFlag')) {
        console.log('removeHead')
        window.location.href = funcUrlDel(window.location.href, 'logoutFlag')
      }
    }
  }

  const onChange = (checked) => {
    handleCk(checked)
  }

  const handleRemember = () =>{
    console.log('formmmmmmm', formRef.current)

    const result = localStorage.getItem(SYSCON.RememberLocal) === 'true'

    console.log('result', typeof result)

    handleCk(result)

    if (result) {
      const info = JSON.parse(localStorage.getItem(SYSCON.LastUserLocal))
      console.log('info', info)
      console.log('window.atob(info.password)', window.atob(info.password))

      formRef.current.setFieldsValue({ phone: info.username })
      formRef.current.setFieldsValue({ password: window.atob(info.password) })
    }
  }

  const setRemember = ()=>{
    const { password, phone } = formRef.current.getFieldsValue(true)
    console.log('totalForm', formRef.current.getFieldsValue(true))
    console.log('remCk', remCk)

    if (remCk) {
      localStorage.setItem(SYSCON.LastUserLocal, JSON.stringify({ username: phone, password: window.btoa(password) }))
      localStorage.setItem(SYSCON.RememberLocal, true)
    } else {
      localStorage.removeItem(SYSCON.LastUserLocal)
      localStorage.setItem(SYSCON.RememberLocal, false)
    }
  }

  const handleRegister = ()=>{
    handleRegistClick()
  }

  const handleForget = ()=>{
    handleForgetClick()
  }
  const cnInputCheck = (event) => {
    return event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s/g, '')
  }

  const handleScanResGet = async(res) => {
    console.log({ res })
    setQrFlag(false)
    handleModalClose()
    if (!res.isRegistered) {
      props.handleWxVerify(res)
      return
    }
    const userInfo = {
      token: res.token,
      orgs: []
    }
    message.success('登录成功')
    await props.user.handleUserInfo(userInfo)
    props.setStatu(props.user.getLoginStatu())
    handleLoginSuccess && handleLoginSuccess(userInfo)
  }

  const [proModalVisible, handleProVisible] = useState(false)
  const [privacyModalVisible, handlePrivacyVisible] = useState(false)

  return (
    <Fragment>
      <div className={styles['title-wrap']}>
        <div className={styles['title']}>
          {qrFlag ? '扫码登录' : '账号密码登录'}
        </div>
        <div className={styles['separator']}></div>
        {qrFlag && <img src={pcLoginImg} alt='' className={styles['login-img']} onClick={() => setQrFlag(!qrFlag)}/>}
        {!qrFlag && <img src={qrLoginImg} alt='' className={styles['login-img']} onClick={() => setQrFlag(!qrFlag)}/>}
      </div>
      {
        qrFlag
          ? <LoginQr getScanRes={handleScanResGet}/>
          : <Form
            ref={formRef}
            name='normal_login'
            className={styles['login-form']}
          >
            <Form.Item
              name='phone'
              rules={[{ required: true, message: '手机号不能为空' }]}
              // 使用 getValueFromEvent 从事件中提取并处理值
              getValueFromEvent={(e) => e.target.value.trim()}
            >
              <Input placeholder='手机号/用户名' />
            </Form.Item>
            <Form.Item
              name='password'
              rules={[{ required: true, message: '密码不能为空' }]}
              getValueFromEvent = {cnInputCheck}
            >
              <Input.Password
                className={styles['select-ban']}
                onCopy={(e) => e.preventDefault()}
                placeholder='密码'
              />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Form.Item
                name='imgCode'
                rules={[{ required: true, message: '验证码不能为空' }]}
                style={{ display: 'inline-block', width: 'calc(74% - 8px)' }}
                getValueFromEvent={(e) => e.target.value.trim()}
              >
                <Input autocomplete='off' placeholder='请输入验证码' />
              </Form.Item>
              <Form.Item
                style={{ display: 'inline-block', width: 'calc(26% - 8px)', margin: '0 8px' }}
              >
                <img onClick={() => reloadCodeImg()} className={styles['v-img']} alt='vcode' src={imgSrc} />
              </Form.Item>
            </Form.Item>
            <Form.Item>
              <Form.Item
                name='ckresult'
                valuePropName='checked'
                noStyle >
                <label style={{ marginRight: '8px', position: 'relative', top: '2px' }}>记住我</label>
                <Switch checked={remCk} onChange={onChange}/>
              </Form.Item>

              <a className={styles['login-form-forgot']} onClick={() => handleForget()}>
              忘记密码
              </a>
            </Form.Item>

            <Form.Item>
              <Button type='primary' htmlType='submit' onClick={() => handleLogin()} className={styles['login-form-button']}>
              登录
              </Button>
            </Form.Item>
          </Form>
      }
      <div style={{ 'marginTop': '10px', textAlign: 'center' }}>登录代表您已阅读并同意<a onClick={() => handleProVisible(true)}>《用户协议》</a>和 <a onClick={() => handlePrivacyVisible(true)}>《用户隐私》</a></div>
      <div className={styles['register-bar']}>
        还没有账号？<a onClick={() => handleRegister()}>立即注册</a>
      </div>
      <Protocol modalVisible={proModalVisible} onCancel={() => handleProVisible(false)}/>
      <Privacy modalVisible={privacyModalVisible} onCancel={() => handlePrivacyVisible(false)}/>
      {/* <ChangePwd ref={changePwdRef} /> */}
    </Fragment>
  )
}

export default wrapWithUser(LoginForm)
